import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-aktion-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAktionAdminEffects {

    VeranstaltungAktionAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_AKTION_ADMIN),
        mergeMap((x: ac.GetVeranstaltungAktionAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungAktionAdmin(x.veranstaltung_id, x.aktionId).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungAktionAdminErfolgreichAction(result, x.veranstaltung_id, x.aktionId, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungAktionAdminFehlerAction(error, x.veranstaltung_id, x.aktionId, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
